import React, { useEffect, useState } from "react";
import { Card, Container, Form, Button, Stack } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";

import { getEnabledGamesApi, setEnabledGamesApi } from "../../apis/coupon";
import toast from "react-hot-toast";
import { customToastStyle, customToastSuccessStyle } from "../../configs/constants";

export default function ManageDashboard() {
    const [enabledGames, setEnabledGames]: [enabledGames: any, setEnabledGames: Function] = useState({});
    const [gamesList, setGamesList]: [gamesList: any, setGamesList: Function] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        (async () => {
            const res = await getEnabledGamesApi();
            setEnabledGames(res);
            setGamesList(res);
        })();
    }, []);

    const saveHandler = async () => {
        setLoading(true);
        const res = await setEnabledGamesApi(JSON.stringify(gamesList));
        if (res) {
            toast("Save successfully", customToastSuccessStyle);
        } else {
            toast("Error to save data", customToastStyle);
        }
        setLoading(false)
    }

    return (
        <Container style={{ marginTop: 50 }}>
            <h2>
                Enable/Disable Games
            </h2>
            <Stack direction="vertical">
                <Stack direction="horizontal">
                    <Card className="w-50 m-2">
                        <Card.Body>
                            <Card.Title>Diamond Price</Card.Title>
                            <Form.Group className="mt-3">
                                {
                                    Object.keys(enabledGames).map(
                                        (item) => <Form.Check type="checkbox" label={item} key={item} checked={gamesList[item]} onChange={(e) => {
                                            setGamesList((prev: any) => {
                                                return ({ ...prev, ...{ [item]: e.target.checked } })
                                            })
                                        }} />
                                    )
                                }
                            </Form.Group>

                            <Form.Group className="mt-3">
                                <Button
                                    onClick={saveHandler}
                                    disabled={loading || JSON.stringify(gamesList) === JSON.stringify(enabledGames)}
                                    style={{ minWidth: 80 }}
                                >
                                    {loading ? (
                                        <Spinner animation="border" role="status" />
                                    ) : (
                                        "Save"
                                    )}
                                </Button>
                            </Form.Group>
                        </Card.Body>
                    </Card>
                </Stack>
            </Stack>
        </Container>
    );
}
